export default function getFullname(user: {
  firstName?: string | null
  insertion?: string | null
  lastName?: string | null
}) {
  return [user.firstName, user.insertion, user.lastName]
    .filter((e) => e != null)
    .join(" ")
}
